import Vue from "vue";
import axios from 'axios';
import VueAxios from 'vue-axios';
// import VueSocialauth from 'vue-social-auth';
import UniversalSocialauth from 'universal-social-auth';
import { ToastPlugin, ModalPlugin , VBToggle } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";
import VueSignaturePad from 'vue-signature-pad';
import VueMask from 'v-mask';

import VueFileAgent from 'vue-file-agent';
import mixin from '@/mixins';
import router from "./router";
import store from "./store";
import App from "./App.vue";

// Global Components
import "./global-components";

// 3rd party plugins
import "@/libs/portal-vue";
import "@/libs/toastification";
import VuexCache from "./cache/VuexCache";

// require
require("@/global-components");
require("@/libs/vue-select");

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);
Vue.use(VueFileAgent);
Vue.use(VueSignaturePad);
Vue.use(VueMask);

// Composition API
Vue.use(VueCompositionAPI);

// Social auth
Vue.use(VueAxios, axios);
const options = {
    providers: {
        google: {
            clientId: process.env.VUE_APP_GOOGLE_LOGIN_CLIENT_ID,
            redirectUri: `${process.env.VUE_APP_URL}/login`
        },
        microsoft: {
            clientId: process.env.VUE_APP_MICROSOFT_LOGIN_CLIENT_ID,
            redirectUri: `${process.env.VUE_APP_URL}/login`
        }, 
    }
};
const Oauth = new UniversalSocialauth(axios, options);
Vue.prototype.$auth = Oauth;

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

Vue.config.productionTip = false;
Vue.prototype.$cache = new VuexCache('custom', store);

store.dispatch("auth/me").then(() => {
    new Vue({
        router,
        store,
        render: h => h(App),
    }).$mount("#app");
});

Vue.mixin(mixin);

// Note: Vue automatically prefixes the directive name with 'v-'
Vue.directive('b-toggle', VBToggle);

// document's click handler
let handleOutsideClick;
Vue.directive('closable', {
    bind (el, binding, vnode) {
        handleOutsideClick = e => {
            e.stopPropagation();
            const { handler, exclude } = binding.value;
            let clickedOnExcludedEl = false;
            exclude.forEach(refName => {
                if (!clickedOnExcludedEl) {
                    const excludedEl = vnode.context.$refs[refName];
                    clickedOnExcludedEl = excludedEl.contains(e.target);
                }
            });
            if (!el.contains(e.target) && !clickedOnExcludedEl) {
                vnode.context[handler]();
            }
        };
        document.addEventListener('click', handleOutsideClick);
        document.addEventListener('touchstart', handleOutsideClick);
    }, unbind () {
        document.removeEventListener('click', handleOutsideClick);
        document.removeEventListener('touchstart', handleOutsideClick);
    }
});
// end document's click handler directive
